<template>
	<span>
		<v-list three-line v-if="rooms.length > 0">
			<template v-for="room in rooms">
				<v-list-item
					:key="room.id"
					class="elevation-3 ma-5"
					:to="`/reserve/room/${room.id}`"
				>
					<v-list-item-avatar size="80" color="blue-grey lighten-3">
						<span v-if="!room.image" class="white--text headline">{{
							room.name | initials
						}}</span>
						<v-img
							v-if="room.image"
							:src="
								`https://${keyword}.libnet.info/images/roombooking/${keyword}/${room.image}`
							"
						></v-img>
					</v-list-item-avatar>

					<v-list-item-content>
						<v-list-item-subtitle class="green--text"
							>Available</v-list-item-subtitle
						>
						<v-list-item-title
							v-html="room.name"
						></v-list-item-title>
						<v-list-item-subtitle
							v-html="getLocationForId(room.location_id).name"
						></v-list-item-subtitle>
					</v-list-item-content>
					<v-spacer></v-spacer>

					<div v-if="room.roomCapacity > 0">
						<v-icon>people_outline</v-icon
						><span class="pl-1">{{ room.roomCapacity }}</span>
					</div>
				</v-list-item>
			</template>
		</v-list>
		<span v-else>Sorry no rooms matching your criteria</span>
	</span>
</template>

<script>
export default {
	name: 'co-room-list',
	props: ['rooms'],
	created() {
		this.keyword = window.config.keyword;
	},
	methods: {
		getLocationForId(id) {
			return this.$store.getters.getLocationForId(id);
		}
	}
};
</script>

<style></style>
